var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h_100",staticStyle:{"overflow":"auto"}},[_c('header-com'),_c('div',{staticClass:"content_area"},[_c('router-view')],1),(_vm.ocrBoxInfo.show)?_c('ocr-identify'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }